import { useMutation } from '@tanstack/react-query'

import { updateBatteryUsableEnergy } from '@/features/resource/endpoints/resources'
import type { BatteryUsableEnergySchemaType } from '@/features/resource/types'
import { convertToWatts } from '@/features/resource/utils/convertToWatts'

export function useUpdateBatteryUsableEnergyMutation(resourceID: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: BatteryUsableEnergySchemaType) => {
      return updateBatteryUsableEnergy(resourceID, convertToWatts(data.userDefinedUsableEnergy))
    },
  })

  return { updateBatteryUsableEnergy: mutateAsync, ...mutationResult }
}
